__turbopack_context__.v({
  "borderedContentWrap": "ineligiblePromoModal-module-scss-module__13IgJW__borderedContentWrap",
  "btn": "ineligiblePromoModal-module-scss-module__13IgJW__btn",
  "btn-alt": "ineligiblePromoModal-module-scss-module__13IgJW__btn-alt",
  "btn-default": "ineligiblePromoModal-module-scss-module__13IgJW__btn-default",
  "btn-default-dark-bg": "ineligiblePromoModal-module-scss-module__13IgJW__btn-default-dark-bg",
  "btn-disabled": "ineligiblePromoModal-module-scss-module__13IgJW__btn-disabled",
  "btn-elite": "ineligiblePromoModal-module-scss-module__13IgJW__btn-elite",
  "btn-gold": "ineligiblePromoModal-module-scss-module__13IgJW__btn-gold",
  "btn-lg": "ineligiblePromoModal-module-scss-module__13IgJW__btn-lg",
  "btn-link": "ineligiblePromoModal-module-scss-module__13IgJW__btn-link",
  "btn-plat": "ineligiblePromoModal-module-scss-module__13IgJW__btn-plat",
  "btn-primary": "ineligiblePromoModal-module-scss-module__13IgJW__btn-primary",
  "btn-sm": "ineligiblePromoModal-module-scss-module__13IgJW__btn-sm",
  "btn-success": "ineligiblePromoModal-module-scss-module__13IgJW__btn-success",
  "btn-warning": "ineligiblePromoModal-module-scss-module__13IgJW__btn-warning",
  "bundlesWrap": "ineligiblePromoModal-module-scss-module__13IgJW__bundlesWrap",
  "buttonWrap": "ineligiblePromoModal-module-scss-module__13IgJW__buttonWrap",
  "cta": "ineligiblePromoModal-module-scss-module__13IgJW__cta",
  "ctaWrap": "ineligiblePromoModal-module-scss-module__13IgJW__ctaWrap",
  "disabled": "ineligiblePromoModal-module-scss-module__13IgJW__disabled",
  "exitButton": "ineligiblePromoModal-module-scss-module__13IgJW__exitButton",
  "imgWrap": "ineligiblePromoModal-module-scss-module__13IgJW__imgWrap",
  "ineligableContainer": "ineligiblePromoModal-module-scss-module__13IgJW__ineligableContainer",
  "innerContainer": "ineligiblePromoModal-module-scss-module__13IgJW__innerContainer",
  "innerModalWrap": "ineligiblePromoModal-module-scss-module__13IgJW__innerModalWrap",
  "modalWrap": "ineligiblePromoModal-module-scss-module__13IgJW__modalWrap",
  "outerIneligableContainer": "ineligiblePromoModal-module-scss-module__13IgJW__outerIneligableContainer",
  "secondaryCta": "ineligiblePromoModal-module-scss-module__13IgJW__secondaryCta",
  "submitButton": "ineligiblePromoModal-module-scss-module__13IgJW__submitButton",
  "uppercase": "ineligiblePromoModal-module-scss-module__13IgJW__uppercase",
});
